import React, { useState, useEffect } from "react";
import UsePanel from "./UserPanel";
import Notifications from "./Notifications";
import SocialSource from "./SocialSource";
import OverView from "./OverView";
import axios from "axios";
import { Container, Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "../../components/Dashboard.css"
import { useLocation, useNavigate } from "react-router-dom";
import OverView3 from "./Overview3";
import MachineStatusChart from "./MachineStatusChart";
import AlarmList from "./LatestAlarms";
import MachineDowntimeTimeline from "./MachineDownTimeTimeLine";
import MonthlyProductionStatus from "../BatchControl/MonthlyProductionStatus";
import DowntimeAnalyticsBar from "./DowntimeAnalyticsBar";
const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const authToken = localStorage.getItem("access");
     const selectedCompanyId = localStorage.getItem('companyid');
  // const authToken = JSON.parse(localStorage.getItem("authUser")).token;
  const [machines, setMachines] = useState([]);
   const [partNum, setPartNum] = useState("");
  const [partsData, setPartsData] = useState({
    good_parts: 0,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    stopped_time: 0,
    machine_stop_time: null,
    good_parts_ago: 0,
    bad_parts_ago: 0,
    total_parts_ago: 0,
    total_running_hours_ago: 0,
    total_parts_1st_shift: 0,
    total_parts_2st_shift: 0,
    total_parts_3st_shift: 0,
  });
  const [totalpartsData, setTotalPartsData] = useState({
    total_parts_1st_shift: 0,
    total_parts_2st_shift: 0,
    total_parts_3st_shift: 0,
  });
  const selectedMachineId = localStorage.getItem('selectedMachineId');
  const [selectedMachine, setSelectedMachine] = useState(partsData?.machine || selectedMachineId || id);
  const [childParts, setChildParts] = useState([]);
  const [selectedChildPart, setSelectedChildPart] = useState(4);
  const [isLoading, setIsLoading] = useState(false);

  const fetchMachine = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`https://api.hanoch.in/api/machines/by-company/?id=${selectedCompanyId}`, {
      
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });

      if (response.ok) {
        const data = await response.json();
        setMachines(data?.data);
      } else if (response.status === 401) {

        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMachine();
  }, []);

  const getProductionDate = () => {
    const now = new Date();

    // Production day starts at 6 AM
    const productionDate = new Date(now);

    if (now.getHours() < 6) {
      productionDate.setDate(now.getDate());
    }

    return productionDate.toISOString().split("T")[0];
  };
  const [selectedDate, setSelectedDate] = useState(getProductionDate());
  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };


  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(getCurrentShift());
  const [partsDataMap, setPartsDataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    dateTimeList: [],
  });

  document.title = "Dashboard | OptiMize ";

  const getAllChildPartValues = () => {
    const allChildParts = [];
    if (childParts && childParts.length > 0) {
      childParts.forEach(item => {
        if (item.childParts && item.childParts.length > 0) {
          item.childParts.forEach(childPart => {
            if (childPart.value) {
              allChildParts.push(childPart.value);
            }
          });
        }
      });
    }
    return [...new Set(allChildParts)];
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
  };

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
  };
  const handleMachineChange = (event) => {
    const machineId = event.target.value;
    setSelectedMachine(machineId);
    localStorage.setItem('selectedMachineId', machineId);
  };
  
  const fetchPLCData = async (date = selectedDate, shift = selectedShift, selectedMachine) => {
try {
    const response = await axios.get(`https://api.hanoch.in/api/mcc-shift-data-view/?shift=${shift}&date=${date}&machine_id=${selectedMachine}`,
      {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`,
        // },
      }
    );
     const data = response;
       setPartNum(data?.part_number);
    setPartsData({
      ...partsData,
      bad_parts: data?.bad_products || 0,
      good_parts: data?.good_products || 0,
      total_parts: data?.total_count || 0,
      machine_stop_time: data?.machine_stop_time,
      total_running_hours: data?.machine_running_hours || 0,
      stopped_time: data?.stopped_time || 0,
      machine: data?.machine_name || "machine name",
      part: data?.part || "part name",
      oee: data?.oee || 0,
      teep: data?.teep || 0,
      part_number: data?.part_number || 0,
      machine_status: data?.machine_status || "Stopped",
      last_updated: data?.time || "00:00:00"
    });
  }
  catch (error) {
    console.error("PLC API error:", error);

    // 🔴 404 → Not Found page
    if (error.response?.status === 404) {
      navigate("/404"); // make sure this route exists
      return;
    }

    // 🟠 Other API errors
    if (error.response) {
      console.error("API Error:", error.response.status);
    } else if (error.request) {
      console.error("No response from server");
    } else {
      console.error("Axios error:", error.message);
    }
  }
   
    }
  let machine_status = (partsData?.machine_status === true) ? "Running" : "Stopped";

  useEffect(() => {
    let intervalId;

    const fetchAndSchedule = async () => {
      if (selectedDate && selectedShift) {
        await fetchPLCData(selectedDate, selectedShift, selectedMachine);
      }
    };

    fetchAndSchedule();

    intervalId = setInterval(() => {
      const currentShift = getCurrentShift();
      const productionDate = getProductionDate();

      if (
        selectedDate === productionDate &&
        Number(selectedShift) === currentShift
      ) {
        fetchAndSchedule();
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [selectedDate, selectedShift, selectedMachine]);

const selectedYear = selectedDate
  ? new Date(selectedDate).getFullYear()
  : new Date().getFullYear();

const selectedMonth = selectedDate
  ? new Date(selectedDate).getMonth() + 1 // JS months are 0-based
  : new Date().getMonth() + 1;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Dashboard" />
          <Card>
            <CardBody className="p-1">
  <div className="d-flex flex-wrap align-items-center"
            style={{
              gap: "12px",
              padding: "12px 16px",
              // backgroundColor: "bg-dark",
              color: "#000000",
              borderRadius: "6px",
              width: "100%"
            }}>
            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginBottom: 0,
                color: "#000000"
              }}>Select Machine:</label>
              
              <select
                className="form-control"
                id="machine"
                name="selectedMachine"
                value={selectedMachine}
                onChange={handleMachineChange}
              >
                <option key="default">Select Machine</option>
                <>
                  {machines?.map((machine, index) => (
                    <option key={index} value={machine?.id}>
                      {machine?.name}
                    </option>
                  ))}
                </>


              </select>
              {/* )} */}
            </div>

            {/* Machine Name Box */}
            {/* <div style={{ 
    backgroundColor: "#21262d", 
    padding: "4px 10px", 
    borderRadius: "6px", 
    border: "1px solid #30363d"
  }}>
    <span style={{ fontWeight: "600", fontSize: "16px" }}>{partsData.machine}</span>
  </div> */}

            {/* Part Name Box */}
            <div style={{
              // backgroundColor: "#21262d",
              padding: "4px 10px",
              // borderRadius: "6px",
              // border: "1px solid #30363d"
            }} className="p-0">
              <span style={{ fontWeight: "600", fontSize: "13px" }}> {partsData.part} :</span>
            </div>
  <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#000000"
              }}>Date:</label>
              <input
                type="date"
                value={selectedDate}
                min="2026-01-27" 
                onChange={handleDateChange}
                max={new Date().toISOString().split('T')[0]}
                style={{
                  padding: "4px 8px",
                  // backgroundColor: "#21262d",
               

                  border: "1px solid #30363d",
                  borderRadius: "6px",
                  fontSize: "13px"
                }}
              />
            </div>
            {/* Shift Selector */}
            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#000000"
              }}>Shift:</label>
              <select
                value={selectedShift}
                onChange={handleShiftChange}
                style={{
                  padding: "4px 8px",
                  // backgroundColor: "#21262d",
               
                  border: "1px solid #30363d",
                  borderRadius: "6px",
                  fontSize: "13px"
                }}
              >
                <option value="">Select shift</option>
                <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")}>6-2 (Shift 1)</option>
                <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
              </select>
            </div>

          

            {/* Machine Status Indicator */}
            <div className="d-flex align-items-center ms-auto ">
              <div className="me-5">
                <h6 className="mb-0">Last updated : {partsData?.last_updated} </h6>
              </div>
              <div className="me-2 blinking-text">
                <img
                  width="22"
                  height="22"
                  src={
                    machine_status === "Running"
                      ? "https://img.icons8.com/ios-filled/50/40C057/filled-circle.png"
                      : "https://img.icons8.com/ios-filled/50/FA5252/filled-circle.png"
                  }
                  alt={`machine-status-${machine_status}`}
                />

              </div>

              <span style={{
                fontSize: "13px",
                fontWeight: "500"
              }}> {machine_status}</span> &nbsp;
              <span>{partsData?.machine_stop_time}</span>
            </div>
          </div>
            </CardBody>
          </Card>
        

          {/* User Panel Charts */}
          <UsePanel partsData={partsData} />
 {/* <MonthlyProductionStatus
  machineId={selectedMachine}
  partId={partNum}
  year={selectedYear}
  month={selectedMonth}
/> */}
          <Row>
            {/* Overview Chart */}
            <Col xl={7}>
              <OverView3 partsDataMap={partsDataMap}
                selectedDate={selectedDate}
                selectedShift={selectedShift}
                selectedMachine={selectedMachine}
                selectedChildPart={selectedChildPart}
              />

            </Col>

            {/* Social Source Chart */}
            <Col xl={5} className="">
              <SocialSource totalpartsData={totalpartsData}
                selectedDate={selectedDate}
                selectedShift={selectedShift}
                selectedMachine={selectedMachine}
              // selectedChildPart={partsData.part_number} 
              />
            </Col>
          </Row>
           <MachineStatusChart
            selectedDate={selectedDate}
            selectedShift={selectedShift}
            selectedMachine={selectedMachine} />
            <MachineDowntimeTimeline
             machineId={selectedMachine}
             date={selectedDate}
             shift={selectedShift}/>
            <AlarmList
            selectedDate={selectedDate}
            selectedShift={selectedShift}
            selectedMachine={selectedMachine} />
            <DowntimeAnalyticsBar 
             machineId={selectedMachine}/>
          </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
